import { CircularProgress } from '@material-ui/core';
import { VerificationFormData } from 'features/customerPanel/accountVerification/interface/verification';
import { FormikErrors, FormikTouched } from 'formik';
import React, { useEffect, useState } from 'react';
import { TFunction } from 'react-i18next';
import FormRow from 'shared/components/form/formRow';
import FormSubTitle from 'shared/components/form/formSubTitle';
import InputRadioGroup from 'shared/components/form/inputRadioGroup';
import { GiifTypesApi } from '../../../../../api';
import { DSInput, DSSelect } from '../../../../../designSystem';
interface Props {
	t: TFunction<'translation'>;
	values: VerificationFormData;
	setFieldValue: (field: string, val: any) => void;
	setFieldError: (field: string, val: any) => void;
	setFieldTouched: (name: string, bool: boolean) => void;
	isFieldValueValid: (field: string, errors: any, touched: {}) => boolean;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<{}>;
	handleBlur: (e: React.FocusEvent<any>) => void;
}

const AccountVerificationFormStep4: React.FC<Props> = ({ t, values, errors, touched, setFieldError, setFieldValue, isFieldValueValid }) => {
	const radioButtons = [
		{ value: false, label: t('notPEP') },
		{ value: true, label: t('isPEP') },
	];
	const [fundSourceOptions, setFundSourceOptions] = useState<any>([]);
	useEffect(() => {
		GiifTypesApi.getGiifTypes().then((response) => {
			setFundSourceOptions(Object.entries(response.data.data.giifTypes).map(([key, value]) => ({ key, value })));
		});
	}, []);
	return (
		<>
			<FormSubTitle
				title={t('verificationStep4SubTitle')}
				dialogTitle={t('verificationStep4ModalTitle')}
				dialogContent={t('verificationStep4ModalDescription')}
			/>
			<FormRow>
				<InputRadioGroup
					name="isPEP"
					values={values}
					radioButtons={radioButtons}
					onChange={(e) => {
						const val = (e.target as HTMLInputElement).value;
						setFieldValue('isPEP', val === 'true' ? true : false);
						setFieldError('isPEP', '');
					}}
					cyTestRef="pep-select"
					rowDirection
				/>
			</FormRow>
			<FormSubTitle title="Określ źródło legalnych środków na grę" />
			<FormRow flex={false} noBottomMargin>
				{fundSourceOptions.length ? (
					<div className={'flex flex-col gap-5'}>
						<DSSelect
							color="green"
							label={t('placeholderChooseFromList')}
							value={values.giifType}
							onChange={(newValue) => setFieldValue('giifType', newValue)}
							options={fundSourceOptions}
						/>
						{values.giifType === '100' && (
							<DSInput
								color="green"
								label={t('mojeId_statements_otherFundSource')}
								value={values.nonDictionaryType}
								onChange={(newValue) => setFieldValue('nonDictionaryType', newValue)}
								error={isFieldValueValid('nonDictionaryType', errors, touched) ? (errors['nonDictionaryType'] as string) : undefined}
							/>
						)}
					</div>
				) : (
					<div className="py-4 m-auto table">
						<CircularProgress color="secondary" size="40px" />
					</div>
				)}
			</FormRow>
		</>
	);
};

export default AccountVerificationFormStep4;
